"use strict";
var isArray = require("../internals/is-array");
var isConstructor = require("../internals/is-constructor");
var isObject = require("../internals/is-object");
var wellKnownSymbol = require("../internals/well-known-symbol");
var SPECIES = wellKnownSymbol("species");
var $Array = Array;
module.exports = function(originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = void 0;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = void 0;
    }
  }
  return C === void 0 ? $Array : C;
};
